import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubscriptionService } from '../../services/subscription.service';
import {
  Inscription,
  inscriptionDictionary,
} from 'src/app/pages/virtual-class/interfaces';
import { HttpService } from 'src/app/services/http.service';
import { BalanceService } from 'src/app/services/balance.service';

@Component({
  selector: 'app-plan-detail',
  templateUrl: './plan-detail.component.html',
  styleUrls: ['./plan-detail.component.scss'],
})
export class PlanDetailComponent implements OnInit {
  @Output() changedStatus$ = new EventEmitter();
  @Input() set subscriptionId(value: number) {
    if (value >= 0) {
      this.inscription = undefined;
      this._lastId = value;
      setTimeout(() => {
        this.getInscription(value);
      });
    }
  }

  public inscriptionStatus = inscriptionDictionary;
  public inscription: Inscription;
  public motive: string = '';
  private _lastId = undefined;

  constructor(
    private subscriptionSv: SubscriptionService,
    private httpSv: HttpService,
    public balanceSv: BalanceService
  ) {}

  ngOnInit() {}

  async getInscription(value: number) {
    const res = await this.httpSv.itemIndex(
      'client/inscription',
      '',
      { id: value },
      'show'
    );
    this.inscription = res.data;

    let dues =
      this.inscription.status === 'Pago'
        ? this.inscription.paymentPending?.dues
        : this.inscription.status === 'Pending'
        ? this.inscription.paymentPending?.dues ||
          this.inscription.paymentAprobed?.dues
        : this.inscription.dues;

    if (dues === 1 && this.inscription.subscription.includesDues) {
      this.motive = `Inscripción + Cuota ${dues}`;
    } else if (dues > 0) {
      this.motive = `Cuota ${dues}`;
    } else if (dues === 0) {
      this.motive = 'Inscripción';
    }
  }

  suspend() {
    this.subscriptionSv.suspend(this.inscription);
  }

  async approveOrDecline(inscription: Inscription, isApprove) {
    await this.subscriptionSv.approveOrDecline(inscription, isApprove);
    await this.getInscription(this._lastId);
    this.changedStatus$.emit();
  }
}
